import { NavigateFunction, useNavigate } from 'react-router-dom';
import { GameType } from '../types/GameType.ts';
import {
  logRouteToGame,
  logRouteToToday,
  logRouteToPrivacyPolicy,
  RouteSourceType
} from './loggingUtils.ts';
import { GameConfig, getGameConfig } from '../types/GameConfig.ts';

class GameNavigation {
  navigate: NavigateFunction;
  gameConfig: GameConfig;

  constructor(navigate: NavigateFunction, gameType: GameType) {
    this.navigate = navigate;
    this.gameConfig = getGameConfig(gameType);
  }

  redirectToTodayGame(source?: RouteSourceType) {
    logRouteToToday(this.gameConfig.type, source, this.gameConfig.type);
    this.navigate(this.gameConfig.routePath);
  }

  redirectToGame(gameType: GameType, source?: RouteSourceType) {
    logRouteToGame(gameType, source, this.gameConfig.type);
    const targetGameConfig = getGameConfig(gameType);
    this.navigate(targetGameConfig.routePath);
  }

  redirectToPrivacyPolicy() {
    logRouteToPrivacyPolicy();
    this.navigate("/privacy");
  }
}

export default function useGameNavigation(gameType: GameType) {
  const navigate = useNavigate();
  return new GameNavigation(navigate, gameType);
}